import { Component, ElementRef, inject, viewChild } from '@angular/core';
import { downloadFile } from '@app/shared/download-utils';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-i18n-settings',
  templateUrl: './admin-i18n.component.html',
  imports: [
    TranslatePipe,
  ],
})
export class AdminI18nComponent {
  private readonly backendService = inject(BackendService);
  private readonly fileInput = viewChild.required<ElementRef>('fileInput');

  export(): void {
    this.backendService.getI18nExcel()
      .subscribe({
        next: downloadFile,
        error: console.error
      });
  }

  chooseFile(): void {
    this.fileInput().nativeElement.click();
  }

  importFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      this.backendService.convertI18nExcel(file)
        .subscribe({
          next: downloadFile,
          error: console.error
        });
    }
  }
}
